export default "__VITE_ASSET__DG_m$gPu__"